import { LoadingButton } from '@mui/lab'
import {
  Alert,
  AlertTitle,
  CircularProgress,
  type SxProps
} from '@mui/material'
import React from 'react'

export const ErrorRetryAlert: React.FC<
  {
    alertText: string
    isRetrying: boolean
    onClick: () => void
  } & { sx?: SxProps }
> = ({ alertText, isRetrying, onClick, ...rest }) => {
  return (
    <Alert
      data-test-error-retry-alert
      action={
        <LoadingButton
          data-test-error-retry-button
          color={isRetrying ? 'primary' : 'inherit'}
          loading={isRetrying}
          loadingIndicator={
            <CircularProgress size={16} sx={{ color: 'error.contrastText' }} />
          }
          size="small"
          variant={isRetrying ? 'contained' : 'outlined'}
          onClick={() => onClick()}
        >
          Retry
        </LoadingButton>
      }
      severity="error"
      sx={{
        width: 'max-content',
        marginTop: 3,
        marginLeft: 3
      }}
      {...rest}
      variant="filled"
    >
      <AlertTitle>{alertText}</AlertTitle>
    </Alert>
  )
}
